module.exports = __webpack_public_path__ + "img/26.4b1102b.jpg";